import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export type InternalStateType = {
  [key: string]: any;
  appName: string;
  isMobile: boolean;
  isSafari: boolean;
  isAndroid: boolean;
  isTablet: boolean;
  screenLocked: boolean;
};

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public onReloadMenu: BehaviorSubject<any>;
  public onReloadSwitch: BehaviorSubject<any>;
  public loading$: Observable<boolean>;
  public onScrollTop = new Subject<any>();
  public loadingAutocomplete$: Observable<boolean>;
  public onReloadNotification = new Subject<any>();
  public onReloadExportMassivo = new Subject<any>();
  public onPrivacyPolicyChange = new Subject<any>();
  private state: InternalStateType = {
    appName: 'Brain Servizi',
    isMobile: false,
    isSafari: false,
    isAndroid: false,
    isTablet: false,
    screenLocked: false
  };

  notificationSocket: SocketIOClient.Socket;

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    this.onReloadMenu = new BehaviorSubject(null);
    this.onReloadSwitch = new BehaviorSubject(null);
  }
  public reloadState(state: InternalStateType) {
    this.state = state;
  }
  public getState(prop?: any): InternalStateType {
    const state = this.state;
    return state.hasOwnProperty(prop) ? state[prop] : null;
  }
  public setState(prop: string, value: any) {
    return (this.state[prop] = value);
  }
  clearState() {
    for (const key in this.state) {
      this.state[key] = null;
    }
  }
}
